import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';

import CurrenciesLinks from 'components/CurrenciesLinks';

import {
  getSortedCurrenciesInfoForLinksSection,
  getCurrenciesPairInfo,
} from 'selectors';

const mapStateToProps = (state, props) => {
  const { source } = getCurrenciesPairInfo(state, props);

  return {
    source,
    currencies: getSortedCurrenciesInfoForLinksSection(state, props),
  };
};

const CurrenciesLinksContainer = injectIntl(
  withRouter(connect(mapStateToProps)(CurrenciesLinks))
);

export default CurrenciesLinksContainer;
